import React from "react";
import styled from "styled-components";
import { designTokens } from "styles/designTokens";
import { getTypography } from "styles/designTokens";
import EmotionSparkleIcon from "./SparkleIcon";

interface SpeakerEmotionBadgeProps {
  speaker: string;
  emotion: string;
  showSpeaker?: boolean;
  showEmotion?: boolean;
  showIcon?: boolean;
}

const speakerColors: { [key: string]: string } = {
  "1": "#4B5EFF",
  "2": "#21C4C4",
  "3": "#FFB84D",
  "4": "#FF23BD",
  "5": "#64748B",
  "6": "#3BB54A",
  "7": "#AA00FF",
};

const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

const SpeakerBadge = styled.span`
  ${getTypography("korean", "body4")}
  color: ${designTokens.colors.font.secondary};
  white-space: nowrap;
`;

const EmotionBadge = styled.span`
  padding: 4px 10px;
  background: #ffffff;
  border: 1px solid ${designTokens.colors.font.quinary};
  border-radius: 4px;
  ${getTypography("korean", "body4")}
  color: ${designTokens.colors.font.tertiary};
  white-space: nowrap;
`;

export const SpeakerEmotionBadge: React.FC<SpeakerEmotionBadgeProps> = ({
  speaker,
  emotion,
  showSpeaker = true,
  showEmotion = true,
  showIcon = false,
}) => {
  const speakerId = speaker.replace("화자 ", "").trim();
  const speakerColor =
    speakerColors[speakerId] || designTokens.colors.font.secondary;

  return (
    <Container>
      {showIcon && <EmotionSparkleIcon color={speakerColor} />}
      {showSpeaker && <SpeakerBadge>{speaker}</SpeakerBadge>}
      {showEmotion && <EmotionBadge>{emotion}</EmotionBadge>}
    </Container>
  );
};

export default SpeakerEmotionBadge;
